import {
  SET_MAINTENANCE_SERVICES,
  CLEAR_SERVICES,
  ADD_MAINTENANCE_NOTES
} from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.maintenance, action) {
  switch (action.type) {
    case SET_MAINTENANCE_SERVICES:
      return action.payload;
    case ADD_MAINTENANCE_NOTES:
      return state.map(service => {
        if (service.id === payload.serviceId) {
          return { ...service, notes: payload.notes };
        } else {
          return service;
        }
      });
    case CLEAR_SERVICES:
    case RESET_APP_STATE:
      return initialState.maintenance;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/maintenance/reducer.js